import { AnyAction } from "@reduxjs/toolkit";
import { SET_FAQS_CONTENT } from "./actionTypes";

export const setFaqsContent = (): AnyAction => {
  return {
    type: SET_FAQS_CONTENT,
  };
};
